import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fetchGuestbookStats } from "../../lib/api";

export default function GuestbookWidget({ className = "" }) {
    const [count, setCount] = useState(null);
    useEffect(() => {
        fetchGuestbookStats()
            .then((s) => setCount(s.total))
            .catch(() => setCount(0));
    }, []);
    return (
        <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.2 }}
            className={className}
        >
            <Link
                to="/gaestebuch"
                data-testid="guestbook-widget"
                className="group flex items-center gap-3 pl-3 pr-4 py-2.5 border border-white/10 bg-black/40 backdrop-blur-xl hover:border-[var(--rb-primary)] transition-all hover:-translate-y-0.5"
            >
                <span className="relative flex items-center justify-center w-8 h-8">
                    <span className="absolute inset-0 rounded-full bg-[var(--rb-primary)]/20 animate-ping" />
                    <span className="relative w-2 h-2 rounded-full bg-[var(--rb-primary)]" />
                </span>
                <span className="font-display text-white text-base leading-none">
                    Gästebuch
                </span>
                {count !== null && (
                    <span className="ml-1 pl-3 border-l border-white/10 text-xs uppercase tracking-[0.24em] text-zinc-400 group-hover:text-[var(--rb-secondary)] transition-colors">
                        {count} {count === 1 ? "Eintrag" : "Einträge"}
                    </span>
                )}
            </Link>
        </motion.div>
    );
}
